import * as React from 'react';
import { Position } from "../position";
import { Box } from "../box";
import { getBox } from "../../primitives";

var getDividerStyles = function getDividerStyles() {
  return {
    height: '1px',
    width: '100%',
    position: 'absolute',
    boxShadow: "inset 0 0 0 1px"
  };
};

var getDividerWrapStyles = function getDividerWrapStyles(props) {
  if (props.inline) {
    return {
      minWidth: !props.width ? '8px' : null,
      alignSelf: 'stretch',
      display: 'flex',
      alignItems: 'center'
    };
  }
};

var _getTextSeparatorStyle = function _getTextSeparatorStyle(props) {
  return {
    height: 'auto',
    color: props.color
  };
};

var TextSeparator = getBox(_getTextSeparatorStyle, ['type']);

var getSeperator = function getSeperator(inlineSeparator) {
  switch (inlineSeparator) {
    case 'vertical':
      return '|';

    case 'slash':
      return '/';

    case 'backslash':
      return '\\';

    case 'dash':
      return '–';

    case 'bullet':
    default:
      return '•';
  }
};

var renderHorizontalDivider = function renderHorizontalDivider(_ref) {
  var width = _ref.width,
      color = _ref.color,
      inline = _ref.inline;
  return /*#__PURE__*/React.createElement(Position, {
    position: "relative",
    width: width,
    _getBaseStyle: getDividerWrapStyles,
    inline: inline
  }, /*#__PURE__*/React.createElement(Box, {
    _getBaseStyle: getDividerStyles,
    color: color
  }));
};

var Divider = function Divider(_ref2) {
  var _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'block' : _ref2$type,
      _ref2$inlineSeparator = _ref2.inlineSeparator,
      inlineSeparator = _ref2$inlineSeparator === void 0 ? 'bullet' : _ref2$inlineSeparator,
      color = _ref2.color,
      width = _ref2.width;

  if (type === 'inline') {
    if (inlineSeparator === 'dash' && width !== undefined) {
      // if width is defined, render the horizontal divider
      return renderHorizontalDivider({
        width: width,
        color: color,
        inline: true
      });
    } // if not, render inline text seperators


    return /*#__PURE__*/React.createElement(TextSeparator, {
      color: color,
      width: width
    }, getSeperator(inlineSeparator));
  }

  return renderHorizontalDivider({
    width: width,
    color: color,
    inline: false
  });
};

Divider.displayName = 'Divider';
export { Divider };
export default Divider;